const imageUpload = document.getElementById("imageUpload");
const previewImage = document.getElementById("previewImage");
const imageContainer = document.getElementById("imageContainer");
const pdfCanvas = document.getElementById("pdfCanvas");

const zoomInButton = document.getElementById("zoomIn");
const zoomOutButton = document.getElementById("zoomOut");
const removeImage = document.getElementById("removeImage");

//const saveStatusButton = document.getElementById("saveStatus");
const containerWidthInput = document.getElementById("containerWidth");
const containerHeightInput = document.getElementById("containerHeight");
const applySizeButton = document.getElementById("applySize");

const fileInput = document.getElementById("imageUploadMultiple");
const fileList = document.getElementById("fileList");
let filesArray = [];

const getData = async function (currUrl, currMethod, currHeaders, currData = '', isFormData) {
  let response;
  if (currData !== '') {
    let bodyCont = "";
    if(isFormData){
      bodyCont = new FormData();
      bodyCont.append('file', currData, currData.name);
    }else{
      bodyCont = JSON.stringify(currData)
    }
    response = await fetch(`${currUrl}`, {
      method: currMethod,
      body: bodyCont,
      headers: currHeaders
    })
  } else {
    response = await fetch(`${currUrl}`, {
      method: currMethod,
      headers: currHeaders
    })
  }
  const responseJSON = await response.json();
  return responseJSON ;
}


fileInput.addEventListener("change", (event) => {
  const files = event.target.files;
  const invalidFiles = [];

  for (const file of files) {
      if (file.type !== "application/pdf") {
          invalidFiles.push(file.name);
      }
  }

  if (invalidFiles.length > 0) {
      alert("Solo se permiten archivos PDF. Archivos no válidos: " + invalidFiles.join(", "));
      event.target.value = ""; // Limpia la selección
  }
  const selectedFiles = Array.from(event.target.files);
  filesArray = [...filesArray, ...selectedFiles];
  updateFileList();
});


async function addProductToCartCustom  (currButton) {

  let currErrors = true;


  $(".checbox-customize").each(function(){
    let currId = $(this).find(`input[type="checkbox"]`).attr("id");
    if(!$(this).hasClass("hide-checkbox")){
      if (!$(`#${currId}`).is(':checked')) {
        $(this).addClass("error-checkbox");
        currErrors = false;
      }
    }
  });

 
  
  if(currErrors){
    
    currButton.attr("disabled", "disabled");
    let oldText = currButton.text().trim();
    currButton.text("Adding...");
    let currId = currButton.attr("id");
    let variantId = currButton.attr("data-prduct-variant-id");
    let specialInstructions = $("#special-instructions").val();
    let properties = {};
    if(specialInstructions){
      properties["Special instructions"] = specialInstructions;
    }
    if (imageUpload.files && imageUpload.files.length > 0) {
    } else {
        properties[`Confirm`] = "I approve blank image";
    }
    $(".popup-label-product__container__left .custom-select-customize").each(function () {
      let currTitle = $(this).find(".custom-select-customize__title").text().trim();
      let currVal = $(this).find(".custom-select-customize__select__current").text().trim();
      let currValue = $(this).find(".custom-select-customize__select__current").attr("data-value");
     
      
      if(currVal && currTitle.toLowerCase() != "quantity" && currTitle.toLowerCase() != "delivery type" && currTitle.toLowerCase() != "material"){
          properties[currTitle] = currVal;
      }
    });
  
    let headers = {
      'Content-type': 'application/json'
    };
    
    if(filesArray.length > 0){
      let responses = [];
      await filesArray.forEach(async file =>{
        try{
          let headers =  {}
          let responseUploadFile = await getData(`/apps/tbd_uploader`, `POST`, headers, file, true);
          if(responseUploadFile.path){
             responses.push(responseUploadFile);
          }
         
        }catch(error){
          console.log(error)
        }
      });
  
      let counterCustom;
      let interval =  setInterval(async () => {
        if (responses.length === filesArray.length || counterCustom >= 10 ) {
  
          if (responses.length > 0) {
            responses.forEach((fileLink, index)=>{
              properties[`File-${index + 1}`] = fileLink.path;
            });
          }
          let data = {id: variantId,quantity: 1, properties: properties};
          try{
            let responseAddToCart = await getData(`/cart/add.js`, `POST`, headers, data, false);
            console.log("response else si templates")
            console.log(responseAddToCart)
            console.log("response else si templates")
            if(responseAddToCart){
              currButton.removeAttr("disabled");
              currButton.text(oldText);
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "It was added correctly",
                showConfirmButton: false,
                timer: 1500
              }).then((result) => {
                window.location.href = "/cart"
              });
            }else{
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: 'Try it later'
              });
            }
          }catch(error){
            console.error("Error:", error);
            currButton.removeAttr("disabled");
            currButton.text(oldText);
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: 'Try it later'
            });
          }
          clearInterval(interval);
        }
        counterCustom++;
      }, 500); 
      
    }else{
      properties[`FILE`] = "No template(s)";
      
      let data = {id: variantId,quantity: 1, properties: properties}
      try{
        let responseAddToCart = await getData(`/cart/add.js`, `POST`, headers, data, false);
        if(responseAddToCart){
          currButton.removeAttr("disabled");
          currButton.text(oldText);
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "It was added correctly",
            showConfirmButton: false,
            timer: 2000
          }).then((result) => {
            window.location.href = "/cart"
          });
        }else{
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: 'Try it later'
          });
        }
      }catch(error){
        console.error("Error:", error);
        currButton.removeAttr("disabled");
        currButton.text(oldText);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: 'Try it later'
        });
      }
    }
  }else{
    Swal.fire({
      title: "Confirm terms",
      text: "By selecting the checkbox, you confirm your understanding and agreement to these terms.",
      icon: "question"
    });
    
  }
  
}

function updateFileList() {
  fileList.innerHTML = "";

  filesArray.forEach((file, index) => {
    const listItem = document.createElement("li");
    listItem.textContent = file.name;

    const removeButton = document.createElement("button");
    removeButton.textContent = "X";
    removeButton.style.marginLeft = "10px";
    removeButton.addEventListener("click", () => {
      removeFile(index);
    });

    listItem.appendChild(removeButton);
    fileList.appendChild(listItem);
  });

  /*if(filesArray.length > 0){
    $("#customize-next").prop("disabled", false);
  }else{
    $("#customize-next").prop("disabled", true);
  }*/

 

}

function removeFile(index) {
  filesArray.splice(index, 1);
  updateFileList();
}


let currentZoom = 1;
let isDragging = false;
let startX,
  startY,
  translateX = 0,
  translateY = 0; 

function updateDetails() {
  $(".cutomize-details-list").html("");
  $(".custom-select-customize").each(function () {
    let currTitle = $(this).find(".custom-select-customize__title").text().trim();
    let currVal = $(this).find(".custom-select-customize__select__current").text().trim();
    let currValue = $(this).find(".custom-select-customize__select__current").attr("data-value");
    if (currTitle.toLowerCase() != "price") {
      $(".cutomize-details-list").append(
        `<li data-value="${currValue}"><span>${currTitle}</span><span>${currVal}</span></li>`
      );
    }
    if (currVal.toLowerCase() == "rounded") {
      $("#imageContainer, #imageContainerParent").addClass("rounded");
    }
    if (currVal.toLowerCase() == "standard") {
      $("#imageContainer, #imageContainerParent").removeClass("rounded");
    }
    if (currTitle.toLowerCase() == "material") {
      if($(`.octo-option-item-color-label`).length > 0){
        $(`.octo-option-item-color-label`).removeClass("active");
        $(`.octo-option-item-color-label[data-material=${currVal}]`).addClass("active");
        $('#models-preview-right a.active').first().trigger('click');
      }
    }
  });
  $(".custom-select-customize.select-quantity .custom-select-customize__select > ul > li").each(function () {
    let currQty =  $(this).attr("data-value");
    let currQtyArr =  currQty.split("-");
    let porcentDesc = currQtyArr[2]; 
    if(false){
       $(this).find("span").html(`${currQty} <small>${porcentDesc}% OFF</small>`);
      //$(this).find("span").html(`${currQtyArr[1]} <small>${porcentDesc}% OFF</small>`);
    }else{
      $(this).find("span").html(`${currQty} `);
      //$(this).find("span").html(`${currQtyArr[1]} `);
    }
  });
}

$(function () {

  if($(".hide-product-info-label-product").length > 0){
    $(".popup-label-product").addClass("active is-product-label");
    $(".popup-label-product__container__close").hide();
  }

  $(document).on("click", "#add-to-cart-btn", function () {
    addProductToCartCustom($(this));
  });
  
  $(document).on("click", ".container-customize-bottles__button", function () {
    $(".popup-label-product").addClass("active");
  });

  $(document).on("click",".popup-label-product__container__close",function () {
    $(".popup-label-product").removeClass("active");
  });

  $(document).on("click",".custom-select-customize__select__current",function () {
      if ($(this).parents(".custom-select-customize").hasClass("active")) {
        $(".custom-select-customize").removeClass("active");
        $(this).parents(".custom-select-customize").removeClass("active");
      } else {
        $(".custom-select-customize").removeClass("active");
        $(this).parents(".custom-select-customize").addClass("active");
      }
    }
  );

  $('.checbox-customize').on('click', function (event) {
    let currIdCheckbox = $(this).find('input[type="checkbox"]').attr("id");
    if (!$(`#${currIdCheckbox}`).prop('checked')) {
      $(this).addClass("error-checkbox");
    } else {
      $(this).removeClass("error-checkbox");
    }
  });

  $(document).on("click",".custom-select-customize__select ul li", function () {
      let currValue = $(this).attr("data-value");
      let currValueText = $(this).find("span").text().trim();
      let currValueParent = $(this).parent().prev().attr("data-value");
      let currValueParentArr = currValueParent.split("-");
      $(this).parent().prev().attr("data-value", `${currValueParentArr[0]}-${currValue}`).html(`${currValueText}<span><img src="https://cdn.shopify.com/s/files/1/0517/2641/8073/files/arrow-down.png?v=1729714949" alt="Select" width="" height="" /></span>`);
      if ($(this).parent().prev().attr("data-id") ) {
        $(`#${$(this).parent().prev().attr("data-id")}`).val(currValueText).trigger("change");
      }
    
      $(this).parents(".custom-select-customize").removeClass("active");
      let divCurrSize = $(`div[data-id="option-size"]`).text().trim().toLowerCase();
      let divCurrSizeArr = divCurrSize.split("x");
      $("#containerWidth").val(Number(divCurrSizeArr[0].replace(/"/g, "")));
      $("#containerHeight").val(Number(divCurrSizeArr[1].replace(/"/g, "")));
      $("#applySize").trigger("click");

      updateDetails();
    }
  ); 

  

  $(document).on("click", "#customize-next, #add-to-cart-btn-skip", function () {
    let currId = $(this).attr("id");
    if(currId === "customize-next" && filesArray.length < 1){
      Swal.fire({
        icon: "error",
        title: "Upload your final design(s)...",
        text: ""
      });
    }else{
      $(".popup-label-product__container__left__first").removeClass("active");
      $(".popup-label-product__container__left__second").addClass("active");
      if(filesArray.length < 1){
        //$("#custom-checkbox-second").parents(".checbox-customize").removeClass("hide-checkbox")
      }else{
        //$("#custom-checkbox-second").parents(".checbox-customize").addClass("hide-checkbox")
      }
    }
  });

  $(document).on("click", "#customize-back", function () {
    $(".popup-label-product__container__left__first").addClass("active");
    $(".popup-label-product__container__left__second").removeClass("active");
  });

  $(document).on("click","#imageContainer span", function () {
    $("#imageUpload").trigger("click");
  });

  $(document).on("click",".download-template-upload", function () {
    $("#imageUploadMultiple").trigger("click"); 
  });

  $(document).on("click",".octo-option-item-color-label", function (e) {
    e.preventDefault();
    $(`.models-preview-left-img`).removeClass("active");
    $(".octo-option-item-color-label").removeClass("octo-selected-color-label");
    $(this).addClass("octo-selected-color-label");
    $(`.models-preview-left-img[data-material="${$(this).attr('data-material')}"][data-color="${$(this).attr('data-color')}"]`).addClass("active");
    $("#models-preview-right-title-color").text($(this).attr('data-color'));
  });

  $(document).on("click", "#customizer-status > div", function () {
    $("#customizer-status > div").removeClass("active");
    $(this).addClass("active");
    let currWidth = inchesToPixels(parseFloat(containerWidthInput.value));
    let currHeight = inchesToPixels(parseFloat(containerHeightInput.value));
    if ($(this).text().trim().toLowerCase() == "guides") {
      $("#imageContainer, #imageContainerParent, #customizer-istructions").removeClass("preview");
    } else {
      $("#imageContainer, #imageContainerParent, #customizer-istructions").addClass("preview");
    }
  });

  let divCurrSize = $(`div[data-id="option-size"]`).text().trim().toLowerCase();
  let divCurrSizeArr = divCurrSize.split("x");
  $("#containerWidth").val(Number(divCurrSizeArr[0].replace(/"/g, "")));
  $("#containerHeight").val(Number(divCurrSizeArr[1].replace(/"/g, "")));
  $("#applySize").trigger("click");
  $(`#option-quantity`).val($(`#option-quantity`).val()).trigger("change");
});

async function generateImageAndDownload({
  zoom,
  translateX,
  translateY,
  width,
  height,
  borderRadius,
  src,
  fileName,
}) {
  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, width, height);

  // Crear una promesa para cargar la imagen
  const img = await new Promise((resolve, reject) => {
    const image = new Image();
    image.src = src;

    image.onload = () => resolve(image);
    image.onerror = (err) => {
      console.error("Error loading image:", err); // Agregar mensaje de error
      reject(err);
    };
  });

  // Calcular las dimensiones de la imagen para mantener la relación de aspecto
  const imgRatio = img.width / img.height;
  let newWidth, newHeight;

  // Ajustar el tamaño de la imagen según el zoom
  newWidth = width * zoom;
  newHeight = height * zoom;

  // Calcular las posiciones para centrar la imagen
  const offsetX = (width - newWidth) / 2 + translateX;
  const offsetY = (height - newHeight) / 2 + translateY;

  // Asegurarse de que el PDF se dibuje correctamente con el offset
  ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);

  // Aplicar el borderRadius
  ctx.globalCompositeOperation = "destination-in";
  ctx.beginPath();
  ctx.moveTo(borderRadius, 0);
  ctx.lineTo(width - borderRadius, 0);
  ctx.quadraticCurveTo(width, 0, width, borderRadius);
  ctx.lineTo(width, height - borderRadius);
  ctx.quadraticCurveTo(width, height, width - borderRadius, height);
  ctx.lineTo(borderRadius, height);
  ctx.quadraticCurveTo(0, height, 0, height - borderRadius);
  ctx.lineTo(0, borderRadius);
  ctx.quadraticCurveTo(0, 0, borderRadius, 0);
  ctx.closePath();
  ctx.fill();

  // Convertir a JPG y devolver la URL de la imagen
  const imageURL = canvas.toDataURL("image/jpeg");

  // Crear un enlace y simular un clic para descargar la imagen
  const link = document.createElement("a");
  link.href = imageURL;
  link.download = `${fileName}.png`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return imageURL;
}

// Function to convert inches to pixels (assuming 96 DPI)
function inchesToPixels(inches) {
  return Math.round(inches * 96);
}

// Function to update container size
function updateContainerSize() {
  const width = inchesToPixels(parseFloat(containerWidthInput.value));
  const height = inchesToPixels(parseFloat(containerHeightInput.value));
  imageContainer.style.width = `${width}px `;
  imageContainer.style.height = `${height}px`;
}

// Initialize container size
updateContainerSize();

// Event listener for apply size button
applySizeButton.addEventListener("click", updateContainerSize);

imageUpload.addEventListener("change", (e) => {
  //removeImageFN();
  $("#imageContainer span").show();
  $("#imageContainer, #imageContainerParent").removeClass("with-file");

  const file = e.target.files[0];
  if (file) {
    const fileType = file.type;
    // Ocultar y mostrar elementos y clases comunes para ambos tipos de archivos
    $("#imageContainer, #imageContainerParent").addClass("with-file");
    $("#imageContainer span").hide();
    previewImage.style.display = "block";
    $("#custom-checkbox-second").parents(".checbox-customize").addClass("hide-checkbox");
    if (fileType === "application/pdf") {
      isPDF = true;
      loadPDF(file);
    } else if (fileType.startsWith("image/")) {
      isPDF = false;
      const reader = new FileReader();
      reader.onload = (event) => {
        previewImage.src = event.target.result;
        currentZoom = 1;
        translateX = 0;
        translateY = 0;
        updateImageTransform();
      };
      reader.readAsDataURL(file);
    }
  }
});

async function loadPDF(file) {
  const reader = new FileReader();
  reader.onload = async (event) => {
    const pdfData = new Uint8Array(event.target.result);
    const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
    const page = await pdf.getPage(1);

    // Obtener el tamaño natural del PDF
    const viewport = page.getViewport({ scale: 1 });

    // Obtener el tamaño del contenedor
    const container = document.getElementById("imageContainer");
    const containerWidth = container.clientWidth;

    // Calcular la escala para ajustar el PDF al contenedor
    const scale = containerWidth / viewport.width;
    const scaledViewport = page.getViewport({ scale }); // Ajusta el viewport según la escala

    pdfCanvas.width = scaledViewport.width;
    pdfCanvas.height = scaledViewport.height;
    const context = pdfCanvas.getContext("2d");

    // Renderizar el PDF en el canvas
    await page.render({ canvasContext: context, viewport: scaledViewport })
      .promise;

    // Ocultar la imagen de vista previa y mostrar el canvas del PDF
    previewImage.style.display = "none";
    pdfCanvas.style.display = "block";

    // Ajustar los valores de transformación y estado
    currentZoom = scale; // Ajusta el zoom al tamaño natural
    translateX = 0;
    translateY = 0;
    updateImageTransform(); // Asegúrate de que esta función actualice la transformación del canvas
  };
  reader.readAsArrayBuffer(file);
}
function zoomImage(delta) {
  const zoomSpeed = 0.1;
  currentZoom += delta * zoomSpeed;
  currentZoom = Math.max(0.1, Math.min(5, currentZoom)); // Limit zoom between 0.1x and 5x
  updateImageTransform();
}

function removeImageFN() {
  $("#imageContainer span").show();
  $("#imageContainer, #imageContainerParent").removeClass("with-file");
  previewImage.src = "";
  previewImage.style.transform = "";
  previewImage.style.cursor = "";
  previewImage.style.display = "none";
  imageUpload.value = null;

  const pdfCanvas = document.getElementById("pdfCanvas");
  if (pdfCanvas) {
    pdfCanvas.style.display = "none";
    pdfCanvas
      .getContext("2d")
      .clearRect(0, 0, pdfCanvas.width, pdfCanvas.height);
  }

  localStorage.removeItem("imageStatus");
  localStorage.clear();
  $("#custom-checkbox-second").parents(".checbox-customize").removeClass("hide-checkbox");
}
zoomInButton.addEventListener("click", () => zoomImage(1));
zoomOutButton.addEventListener("click", () => zoomImage(-1));
removeImage.addEventListener("click", () => removeImageFN());

// Mouse wheel zoom
imageContainer.addEventListener("wheel", (e) => {
  e.preventDefault();
  const delta = e.deltaY > 0 ? -1 : 1;
  zoomImage(delta);
});

function updateImageTransform() {
  previewImage.style.transform = `translate(${translateX}px, ${translateY}px) scale(${currentZoom})`;
  pdfCanvas.style.transform = `translate(${translateX}px, ${translateY}px) scale(${currentZoom})`;
}

/*saveStatusButton.addEventListener("click", () => {
  let currVal = $(
    ".custom-select-customize.select-corners .custom-select-customize__select__current"
  )
    .text()
    .trim();
  let currBorderRadius = currVal.toLowerCase() === "rounded" ? "10px" : "0px";

  // Guardar el estado de la imagen o PDF en el contenedor
  const containerStyles = window.getComputedStyle(imageContainer);
  const imageStatus = {
    zoom: currentZoom,
    translateX:
      typeof translateX === "string"
        ? parseFloat(translateX.replace("px", ""))
        : translateX,
    translateY:
      typeof translateY === "string"
        ? parseFloat(translateY.replace("px", ""))
        : translateY,
    containerWidth: containerStyles.width,
    containerHeight: containerStyles.height,
    borderRadius: currBorderRadius,
    src: previewImage.src || pdfCanvas.toDataURL(), // Prioriza imagen o PDF en canvas
  };

  localStorage.setItem("imageStatus", JSON.stringify(imageStatus));

  // Crear y descargar la imagen generada para visualización actual de PDF o imagen
  const imgData = {
    zoom: currentZoom,
    translateX: imageStatus.translateX,
    translateY: imageStatus.translateY,
    width: parseFloat(containerStyles.width),
    height: parseFloat(containerStyles.height),
    borderRadius: parseFloat(currBorderRadius.replace("px", "")),
    src: previewImage.src || pdfCanvas.toDataURL(),
  };

  generateImageAndDownload(imgData).then((imageUrl) => {
    console.log(imageUrl); // Muestra la URL de la imagen generada
  });

  alert("Estado guardado!");
});*/

// Load saved status on page load
window.addEventListener("load", () => {
  const savedStatus = localStorage.getItem("imageStatus");
  if (savedStatus) {
    const {
      src,
      zoom,
      translateX: savedX,
      translateY: savedY,
    } = JSON.parse(savedStatus);
    if (src.endsWith("pdf")) {
      loadPDF(src);
    } else {
      previewImage.src = src;
    }
    currentZoom = zoom;
    translateX = savedX;
    translateY = savedY;
    updateImageTransform();
  }
});

// Dragging functionality
imageContainer.addEventListener("mousedown", startDragging);
document.addEventListener("mousemove", drag);
document.addEventListener("mouseup", stopDragging);

/*saveStatusButton.addEventListener("click", () => {
  const imageStatus = {
    zoom: currentZoom,
    translateX,
    translateY,
    src: previewImage.src || pdfCanvas.toDataURL(),
  };
  localStorage.setItem("imageStatus", JSON.stringify(imageStatus));
  alert("Image status saved!");
});*/

function startDragging(e) {
  isDragging = true;
  startX = e.clientX - translateX;
  startY = e.clientY - translateY;
}

function drag(e) {
  if (!isDragging) return;
  e.preventDefault();
  translateX = e.clientX - startX;
  translateY = e.clientY - startY;
  updateImageTransform();
}

function stopDragging() {
  isDragging = false;
}

// Prevent dragging from causing unintended selections
imageContainer.addEventListener("dragstart", (e) => e.preventDefault());

removeImageFN();
